import { BaseRouteService } from 'core/services';

class PalletRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'pallets/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	exitScan(resource, sourceOfChange) {
		return super.update(this.base + 'exit-scan/{id}/?sourceOfChange={sourceOfChange}', resource, {sourceOfChange});
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, {sourceOfChange});
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default PalletRouteService;
